import CreateItemButton from "components/buttons/create";
import List from "components/list";
import { PermissionControlledInput } from "permissions/components/input";
import HeaderPortal from "components/portal/header-portal";

export default function Countries() {

    const columns = [
        {
            id: "name",
            header: "Name",
            accessorKey: "name",
            sortable: true,
        },
    ];

    const fields = ["id", "name"];


    return (
        <div className="w-full">
            <HeaderPortal>
                <PermissionControlledInput
                    rule={"create:*"}
                    collection="countries"
                    showWhenDisabled={false}
                >
                    <CreateItemButton href>Countries</CreateItemButton>
                </PermissionControlledInput>
            </HeaderPortal>
            <div className="flex-1 h-full">
                <List
                    title="Countries"
                    endPoint="countries"
                    columns={columns}
                    meta={{
                        fields,
                    }}
                    sortBy="name"
                    sortOrder="aesc"
                    href={(item) => item.id}
                />
            </div>
        </div>
    );
}
